import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { setToStartOfMonth } from 'helpers/date';
import { FormDetails } from 'util/singletons';
import { isPVQForm } from 'helpers/form';
import { federalAgencyList } from 'constants/enums/sharedOptions';
import { HistoryFederalModel, HistoryFederalItemModel } from './types';
import { historyEmploymentReprimandValidator } from '../employment/validators/fields';

export const historyFederalItemValidator: ValidateJSModel<HistoryFederalItemModel> = {
  Position: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { presence: true, hasValue: true };
  },
  Address: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return {
      presence: true,
      location: {
        validator: locationAddressModelValidator,
        allowPOBox: false,
        militaryAddress: true,
      },
    };
  },
  Dates: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;

    return {
      presence: true,
      daterange: {
        earliest: setToStartOfMonth(applicantBirthdate),
        latest: DEFAULT_LATEST,
      },
    };
  },
  Name: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),
  Reprimand: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (!isPVQForm(formDetails.formType)) {
      return {};
    }

    const { Dates } = attributes;

    return {
      presence: true,
      branchCollection: {
        validator: historyEmploymentReprimandValidator,
        Dates,
      },
    };
  },
  ReasonLeft: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (!isPVQForm(formDetails.formType)) {
      return {};
    }

    return { presence: true, hasValue: true };
  },
  Branch: (value, attributes, attributeName, options) => {
    const formDetails = FormDetails.getInstance().getData();
    if (!isPVQForm(formDetails.formType)) {
      return {};
    }

    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
};

const historyFederalValidator: ValidateJSModel<HistoryFederalModel> = {
  HasFederalService: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },
  List: (value, attributes) => {
    // Only required if HasFederalService is yes
    if (attributes?.HasFederalService?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: historyFederalItemValidator },
      };
    }

    return {};
  },
};

export default historyFederalValidator;
